import { render, staticRenderFns } from "./straordinari.vue?vue&type=template&id=3746a191"
import script from "./straordinari.vue?vue&type=script&lang=js"
export * from "./straordinari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports